import { queryClient } from '@/client/query';
import { useMutation, useQuery } from '@tanstack/react-query';

const navbarHeightQueryKey = ['navbarHeight', 'get'];
const intercomStatusQueryKey = ['intercom', 'status'];
const footerVisibilityQueryKey = ['footer', 'visibility'];
// This next array is to avoid showing the footer for a fraction
// of a second before the useSetFooterVisible has been able to fire
const footerVisibilityDefaultExceptions = ['testing-plan/complete-test'];

export function useGetNavbarHeight() {
  return useQuery({
    queryKey: navbarHeightQueryKey,
    initialData: () => 56,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export function useSetNavbarHeight() {
  return useMutation({
    mutationFn: (height: number) => Promise.resolve(height),
    onSuccess: (height: number) => {
      queryClient.setQueryData(navbarHeightQueryKey, height);
    },
  });
}

export function useGetIntercomIsVisible() {
  return useQuery({
    queryKey: intercomStatusQueryKey,
    initialData: () => true,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: 'always',
  });
}

export function useSetIntercomIsVisible() {
  return useMutation({
    mutationFn: (status: boolean) => Promise.resolve(status),
    onSuccess: (status: boolean) => {
      queryClient.setQueryData(intercomStatusQueryKey, status);
    },
  });
}

export function useGetFooterIsVisible() {
  return useQuery({
    queryKey: footerVisibilityQueryKey,
    initialData: () =>
      !footerVisibilityDefaultExceptions.find((exception) => window.location.pathname.includes(exception)),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: 'always',
  });
}

export function useSetFooterIsVisible() {
  return useMutation({
    mutationFn: (isVisible: boolean) => Promise.resolve(isVisible),
    onSuccess: (isVisible: boolean) => {
      queryClient.setQueryData(footerVisibilityQueryKey, isVisible);
    },
  });
}
